import * as t from 'io-ts';
import {isString} from 'lodash';

import {enforceType} from '../../../libs/shared/helpers/src/typescript/typeHelpers';
import {randomString} from '../../../libs/shared/helpers/src/utilities/stringHelpers';
import {NewPanelId, RPanelId} from './panelStateBase';

/*
 * Types.
 */

interface PanelCancelTokenIdBrand {
  readonly PanelCancelTokenId: unique symbol;
}

export const RPanelCancelTokenId = t.brand(
  t.string,
  (id): id is t.Branded<string, PanelCancelTokenIdBrand> => {
    const separatorIndex = id.lastIndexOf('-');
    const panelId = id.slice(0, separatorIndex);
    const uniqueId = id.slice(separatorIndex + 1);

    return RPanelId.is(panelId) && isString(uniqueId) && uniqueId.length === 32;
  },
  'PanelCancelTokenId',
);

export type PanelCancelTokenId = t.TypeOf<typeof RPanelCancelTokenId>;

/*
 * Helpers.
 */

export function makePanelCancelTokenId(panelId: NewPanelId) {
  return enforceType(RPanelCancelTokenId, `${panelId}-${randomString()}`);
}
